// Indicate the state of the generation process
// Idle - No generation in progress
// Loading - Sent request to server and waiting for a response
// Generating - Currently reading the streaming response from the server
enum GenerationState {
  Idle = 'idle',
  Loading = 'loading',
  Generating = 'generating',
}

export { GenerationState };
